export default __webpack_public_path__ + "static/media/ico_user_alt_phone_light.c5dda723.svg";